import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

type Props = {
  title: string;
  subtitle?: string;
};

const PlaceholderPage: React.FC<Props> = ({ title, subtitle }) => {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 560 }}>
      <Typography variant="h5" fontWeight={800} gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {subtitle || 'This module is on the roadmap. You will be able to trigger syncs, review history, and audit changes per workspace.'}
      </Typography>
      <Button variant="outlined" onClick={() => navigate('/')}>
        Back to overview
      </Button>
    </Box>
  );
};

export default PlaceholderPage;
